import http from '@/http'

const find = id => {
	const path = `users/${id}`
	return http.get(path)
}

const getAll = ({ field, order }, perPage = 10, pageNr = 1, filter, searchText) => {
	let filterSegment = ''
	let searchSegment = ''

	if (filter) {
		if (typeof filter.value === 'boolean')
			filterSegment += `&${filter.by}[exists]=${filter.value}`
		else if (Array.isArray(filter.value))
			filter.value.forEach(value => {
				filterSegment += `&${filter.by}[]=${value}`
			})
		else filterSegment += `&${filter.by}=${filter.value}`
	}

	if (searchText) searchSegment = `&search=${searchText}`

	const path = `users?order[${field}]=${order}&itemsPerPage=${perPage}&page=${pageNr}${filterSegment}${searchSegment}`
	return http.get(path)
}

const update = user => {
	const path = `users/${user.id}`
	if (user.user) user.user = `/api/users/${user.user.id}`
	if (user.orders) delete user.orders
	if (!user.plainPassword) delete user.plainPassword
	return http.put(path, user)
}

const create = user => {
	const path = `users`
	return http.post(path, user)
}

const destroy = user => {
	const path = `users/${user.id}`
	return http.delete(path)
}

export default {
	find,
	getAll,
	create,
	update,
	destroy
}
